import { getTeamLeaguesTeamsUseCase } from '@/domain/use-cases/get-team-leagues-teams.use-case';
import { Result } from '@/entities/Result';
import { TeamInfo } from '@/entities/TeamLeagueTeamInfo';

export const getTeamLeaguesTeamsController = async (
	organizationUuid: string,
	teamLeagueUuid: string,
	teamUuid: string
): Promise<Result<TeamInfo>> => {
	return getTeamLeaguesTeamsUseCase(organizationUuid, teamLeagueUuid, teamUuid);
};
